import { TsRestClient } from '@eluve/api-client-provider';
import { SessionUnavailableError } from '@eluve/eluve-errors';
import { Logger } from '@eluve/logger-main';

import { AddAppointmentTagEvent, TaskHandler } from '../types';

export const addAppointmentTagHandler = ({
  client,
  logger,
}: {
  client: TsRestClient | null;
  logger: Logger;
}): TaskHandler<AddAppointmentTagEvent> => {
  return async (task, context) => {
    if (!client) {
      logger.warn('API client is not available');
      throw new SessionUnavailableError('API client not initialized');
    }

    const response = await client.appointments.addAppointmentTag({
      body: {
        type: task.tag.type,
        key: task.tag.key,
        fileId: task.fileId,
        metadata: task.metadata,
      },
      params: {
        tenantId: context.tenantId,
        appointmentId: task.appointmentId,
      },
      fetchOptions: { signal: context.signal },
    });

    if (response?.status === 401) {
      throw new SessionUnavailableError(
        'Session expired while adding appointment tag',
      );
    }

    if (response?.status === 403) {
      logger.warn('Appointment not accessible while adding appointment tag', {
        appointmentId: task.appointmentId,
        tag: task.tag,
      });
      return;
    }

    if (response?.status !== 200) {
      logger.warn('Failed to add appointment tag', {
        appointmentId: task.appointmentId,
        tag: task.tag,
        status: response?.status,
      });

      throw new Error(
        `Failed to add appointment tag. Status: ${response.status}`,
      );
    }
  };
};
